// deps
import styled, { css } from "styled-components";

// internal-deps
import { AriaHidden } from "@swiggy-private/core-ui";
import { getCornerRadius } from "@swiggy-private/dls-web-common/dist/components/themes/CornerRadiusMapping/mapping";

// base styles
const buttonResetStyles = css`
    background: transparent;
    border: none;
    outline: none;
    padding: 0;
    text-align: left;
    appearance: none;
    -webkit-appearance: none;
`;

// styled components
export const ContentButtonStyled = styled.button<{ isAutoAddXp: boolean }>`
    ${buttonResetStyles}
    ${props => props.theme.typography["V2.body2.neutral.medium"]}
    background: ${props => props.theme.colors[props.theme.colorMode].background_Primary};
    border: 1px solid ${props => props.theme.colors[props.theme.colorMode].divider};
    border-radius: ${props => getCornerRadius(props.theme, "xSmall")};
    color: ${props => props.theme.colors[props.theme.colorMode].text_Med_Emphasis};
    display: flex;
    align-items: center;
    padding: ${props => props.theme.spacing.xSmall} ${props => props.theme.spacing.small} ${props =>
    props.theme.spacing.xSmall} ${props => props.theme.spacing.xSmall};
`;

export const IconStyled = styled(AriaHidden)`
    margin-right: 6px;
    margin-bottom: ${props => props.theme.spacing.xxxSmall};
    position: relative;
`;

export const TextWrapper = styled.div`
    margin-top: 1px;
`;
